import base64 from 'base-64'
import Cookies, { remove } from 'js-cookie'

export const TOKEN = 'token'
export const EXPIRES_ON = 'expires_on'
export const EXPIRES_DATE = 'expires_date'
export const USER_ID = 'user_id'
export const EMP_ID = 'emp_id'
export const FULL_NAME = "fullname"
export const ROLE = "role"
export const EMAIL = "email"
export const O365_TOKEN = "o365_token"
export const USER_IMAGE = "user_image"
export const IS_NPI_ADMIN = "is_npi_admin"
export const IS_ADMIN = "is_admin"
export const STATION_DISPLAY = "station_display"
export const PICKING_DISPLAY = "picking_display"
export const REPORT_AS_FINISH_DISPLAY = "report_as_finish_display"
export const JOB_CARD_DISPLAY = "job_card_display"
export const WARE_HOUSE_DISPLAY = "ware_house_display"
export const STATION_NAME_DISPLAY = "station_name_display"
export const DISPLAY_SETTINGS = "display_settings"

export const DISPLAY_NAME = "display_name"
export const TABLE_NAME_ACTIVE = "table_name_active"

function getCookie(key) {
    try {
        const value = Cookies.get(key)
        let setValue = ''

        if (value && typeof value === 'string') {
            setValue = base64.decode(value)
        }

        return setValue
    } catch (error) {
        return null
    }

}

function setCookie(key, value, expires) {
    const valueToString = String(value)
    let setValue = ''
    if (typeof valueToString === 'string') {
        setValue = base64.encode(valueToString)
    }
    if (expires && typeof expires === "number" && expires > 0) {
        Cookies.set(key, setValue, { expires: expires })
    } else {
        Cookies.set(key, setValue)
    }

}

function removeCookie(key) {
    Cookies.remove(key)
}

export function authentication(dataAuth, isRemember) {
    const { user: { email, fullName, id, isNpiAdmin, isAdmin }, token, expiresDate, expiresOn } = dataAuth

    clearToken()
    setCookie(FULL_NAME, fullName)
    setCookie(EMAIL, email)
    setCookie(USER_ID, id)

    setCookie(TOKEN, token)
    setCookie(EXPIRES_DATE, expiresDate)
    setCookie(EXPIRES_ON, expiresOn)
    setCookie(IS_NPI_ADMIN, isNpiAdmin)
    setCookie(IS_ADMIN, isAdmin)
}
export function setO365TokenCookie(data) {
    setCookie(O365_TOKEN, data)
}
export function getO365Token() {
    return getCookie(O365_TOKEN)
}

export function setUserImageCookie(data) {
    setCookie(USER_IMAGE, data)
}
export function getUserImageCookie() {
    return getCookie(USER_IMAGE)
}
export function clearToken() {
    removeCookie(TOKEN)
    removeCookie(EXPIRES_DATE)
    removeCookie(USER_ID)
    removeCookie(FULL_NAME)
    removeCookie(EMAIL)
    removeCookie(IS_ADMIN)
    removeCookie(IS_NPI_ADMIN)
}

export function getAllCookies() {
    return {
        [TOKEN]: getCookie(TOKEN),
        [EXPIRES_ON]: getCookie(EXPIRES_ON),
        [EXPIRES_DATE]: getCookie(EXPIRES_DATE),
        [USER_ID]: getCookie(USER_ID),
        [IS_NPI_ADMIN]: getCookie(IS_NPI_ADMIN),
        [IS_ADMIN]: getCookie(IS_ADMIN)
    }
}

export function getToken() {
    return getCookie(TOKEN)
}

export function getFullName() {
    return getCookie(FULL_NAME)
}

export function getRole() {
    return getCookie(ROLE)
}

export function getExpireDate() {
    return getCookie(EXPIRES_DATE)
}

export function getIsNpiAdmin() {
    return getCookie(IS_NPI_ADMIN)
}

export function getIsAdmin() {
    return getCookie(IS_ADMIN)
}


export function authenticationEmpMode(dataAuth, isRemember) {
    const { user: { email, empId, fullName, id, isNpiAdmin, isAdmin }, token, expiresDate, expiresOn } = dataAuth.data

    clearToken()
    setCookie(FULL_NAME, fullName)
    setCookie(EMAIL, email)
    setCookie(USER_ID, id)
    setCookie(EMP_ID, empId)
    setCookie(TOKEN, token)
    setCookie(EXPIRES_DATE, expiresDate)
    setCookie(EXPIRES_ON, expiresOn)
    // setCookie(IS_NPI_ADMIN, isNpiAdmin)
    // setCookie(IS_ADMIN, isAdmin)
}


//getAllCokiesDisplay
export function getAllCookiesDisplay() {
    return {
        [STATION_DISPLAY]: getCookie(STATION_DISPLAY),
        [PICKING_DISPLAY]: getCookie(PICKING_DISPLAY),
        [REPORT_AS_FINISH_DISPLAY]: getCookie(REPORT_AS_FINISH_DISPLAY),
        [JOB_CARD_DISPLAY]: getCookie(JOB_CARD_DISPLAY),
        [WARE_HOUSE_DISPLAY]: getCookie(WARE_HOUSE_DISPLAY),
        [USER_ID]: getCookie(USER_ID),
        [EMP_ID]: getCookie(EMP_ID),
        [FULL_NAME]: getCookie(FULL_NAME),
        [STATION_NAME_DISPLAY]: getCookie(STATION_NAME_DISPLAY),
        [DISPLAY_NAME]: getCookie(DISPLAY_NAME),
        [TABLE_NAME_ACTIVE]: getCookie(TABLE_NAME_ACTIVE)
    }
}

//set all cookie display
export function setCookieDisplay(data) {
    const { stationDisplay, pickingDisplay, reportAsFinishDisplay, jobCardDisplay, warehouseDisplay, stationName } = data
    setCookie(STATION_DISPLAY, stationDisplay)
    setCookie(PICKING_DISPLAY, pickingDisplay)
    setCookie(REPORT_AS_FINISH_DISPLAY, reportAsFinishDisplay)
    setCookie(JOB_CARD_DISPLAY, jobCardDisplay)
    setCookie(WARE_HOUSE_DISPLAY, warehouseDisplay)
    setCookie(STATION_NAME_DISPLAY, stationName)


}

//clear all cookie display
export function clearCookieDisplay() {
    removeCookie(STATION_DISPLAY)
    removeCookie(PICKING_DISPLAY)
    removeCookie(REPORT_AS_FINISH_DISPLAY)
    removeCookie(JOB_CARD_DISPLAY)
    removeCookie(WARE_HOUSE_DISPLAY)
    removeCookie(STATION_NAME_DISPLAY)
    removeCookie(USER_ID)
    removeCookie(EMP_ID)
    removeCookie(FULL_NAME)
    removeCookie(DISPLAY_NAME)
    removeCookie(TABLE_NAME_ACTIVE)
}

export function setDisplayName(name) {
    console.log(name)
    setCookie(DISPLAY_NAME, name)
}

export function getDisplayName() {
    return {
        [DISPLAY_NAME]: getCookie(DISPLAY_NAME)
    }
}

export function setTableNameActive(name) {
    setCookie(TABLE_NAME_ACTIVE, name)
}

export function getTableNameActive() {
    return {
        [TABLE_NAME_ACTIVE]: getCookie(TABLE_NAME_ACTIVE)
    }
}




// WEBPACK FOOTER //
// ./src/lib/auth.js